import styled from 'styled-components';

const StyledContainer = styled.div`
  max-width: 800px;
  margin: 20px auto;
  border: 1px solid black;
  padding: 20px;
  background-color: rgba(51, 58, 83, 0.8);
  box-shadow: 1px 1px 5px black;
  border-radius: 5px;
`;

export default StyledContainer;
